<template>
  <div class="order-detail-wrapper">
    <progress-bar :activeIndex="4" />
    <div class="content-wrapper">
      <OrderDetailContent>
        <template v-slot:orderCustom="{ orderInfo }">
          <div class="order-custom" v-if="orderInfo">
            <div v-if="orderInfo && orderInfo.orderStatus == 'WP'" class="custom-button" @click="$toPay(orderInfo.serialNo)">支付</div>
          </div>
        </template>
      </OrderDetailContent>
    </div>
  </div>
</template>

<script>
import ProgressBar from "@/components/ProgressBar";
import OrderDetailContent from "./components/OrderDetailContent.vue";

export default {
  name: "IntOrderPayDetail",
  components: { ProgressBar, OrderDetailContent },
};
</script>

<style lang="less" scoped>
.order-detail-wrapper {
  .content-wrapper {
    width: 1200px;
    margin: 16px auto;
  }
}
.order-custom {
  width: fit-content;
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  .custom-button {
    width: 50px;
    background-color: #d70039;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    padding: 4px 8px;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
